import { API_ENDPOINTS } from './Constants';
import { apiFetch } from './apiHelper';

export const BookService = {
  getBooks: async (page, size) => {
    try {
      const response = await apiFetch(`${API_ENDPOINTS.BOOK}?page=${page}&size=${size}`);
      if (!response.ok) throw new Error("Greška pri dohvaćanju knjiga");
      const res = await response.json();
      return res;
    } catch (error) {
      console.error("Greška pri dohvaćanju knjiga:", error);
      throw error;
    }
  },

  getBookThumbnail: async (id) => {
    try {
      const response = await apiFetch(`${API_ENDPOINTS.BOOK}/${id}/thumbnail`);
      if (!response.ok) throw new Error("Thumbnail nije pronađen");

      const blob = await response.blob();
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  getBookById: async (id) => {
    try {
      const response = await apiFetch(`${API_ENDPOINTS.BOOK}/${id}`);
      if (!response.ok) throw new Error("Knjiga nije pronađena");
      return await response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  searchBooks: async (query, field = "name", page = 0, size = 10, genreId = null, sortBy = "date", sortDir = "desc") => {
    try {
      let url = `${API_ENDPOINTS.SEARCH_BOOKS}?query=${encodeURIComponent(query)}&field=${field}&page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`;
      if (genreId) url += `&genreId=${genreId}`;
      const response = await apiFetch(url);
      if (!response.ok) throw new Error("Greška pri pretraživanju knjiga");
      return await response.json();
    } catch (error) {
      console.error("Greška pri pretraživanju knjiga:", error);
      throw error;
    }
  },

  addBook: async (formData) => {
    try {
      const response = await apiFetch(API_ENDPOINTS.BOOK, {
        method: "POST",
        body: formData,
        credentials: "include",
      });

      if (response.status !== 201) {
        const errorText = await response.text();
        throw new Error(errorText || "Greška pri dodavanju knjige");
      }

      return await response.json();
    } catch (error) {
      console.error("Greška pri dodavanju knjige:", error);
      throw error;
    }
  },

  getSimilarBooks: async (bookId, limit = 4) => {
    try {
      const response = await apiFetch(`${API_ENDPOINTS.BOOK_SIMILAR(bookId)}?limit=${limit}`);
      if (!response.ok) return [];
      return await response.json();
    } catch {
      return [];
    }
  },

  getRecommendations: async (limit = 6) => {
    try {
      const response = await apiFetch(`${API_ENDPOINTS.BOOK_RECOMMENDATIONS}?limit=${limit}`);
      if (!response.ok) return [];
      return await response.json();
    } catch {
      return [];
    }
  },

  updateBook: async (id, formData) => {
    try {
      const response = await apiFetch(`${API_ENDPOINTS.BOOK}/${id}`, {
        method: "PUT",
        body: formData,
        credentials: "include",
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Greška pri ažuriranju knjige");
      }

      return await response.json();
    } catch (error) {
      console.error("Greška pri ažuriranju knjige:", error);
      throw error;
    }
  },
};

export default BookService;
